import React, { useEffect, useState } from "react";



import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import CustomContainer from '../components/Customsettingscontain';
import CustomCard from '../components/Customsettingscard';
// import StatCard from "../components/Statecard";

// import {
//   AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer
// } from "recharts";

// const data = [
//   { day: "01", dau: 30, users: 8, posts: 0 },
//   { day: "03", dau: 42, users: 16, posts: 0 },
//   { day: "05", dau: 38, users: 14, posts: 0 },
//   { day: "07", dau: 29, users: 8, posts: 0 },
//   { day: "09", dau: 10, users: 4, posts: 10 }
// ];
// import {
//   LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid , Area
// } from "recharts";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNavigate } from "react-router-dom";
import Chart from "react-apexcharts";
import axios from 'axios';
import { ApiUrl } from '../Constants/Weburl';
import { NavLink } from "react-router-dom";
import Layout from "../components/Layout";

export default function Dashboard() {

  const navigate = useNavigate();
  const [usercount , setUserscount] = useState([]);
  const [alluserscount, setAllUsersCount] = useState([]);
  const [reports, setReports] = useState([]);
  const [postsreports, setPostReports] = useState([]);
  const [usersreports, setUsersReports] = useState([]);
  const [allwithdrawals , setAllwithdrawals] = useState([]);
  const [type, setType] = useState("post");
  const [analytics, setAnalytics] = useState([]);
    const [moderateusers, setModerateUsers] = useState([]);
  
  // const [month, setMonth] = useState(12);
  // const [year, setYear] = useState(2025);
  const today = new Date();

  const [month, setMonth] = useState(today.getMonth() + 1); // January = 1
  const [year, setYear] = useState(today.getFullYear());

  const currentYear = today.getFullYear();
  const yearOptions = Array.from({ length: 4 }, (_, i) => currentYear - 2 + i);
  

const monthOptions = Array.from({ length: 12 }, (_, i) => ({
  value: i + 1,
  label: new Date(2000, i, 1).toLocaleDateString("en-US", { month: "long" }),
}));
  const [liveUsers, setLiveUsers] = useState(0);



  //collapsed state
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    fetchAnalytics();
  }, [month, year]);





  const getDatesInMonth = (year, month) => {
    const dates = [];
    const days = new Date(year, month, 0).getDate();

    for (let i = 1; i <= days; i++) {
      dates.push(
        `${year}-${String(month).padStart(2, "0")}-${String(i).padStart(2, "0")}`
      );
    }
    return dates;
  };

  const fetchAnalytics = async () => {
    try {
      const token = localStorage.getItem("adminToken");

      const res = await axios.get(
        `${ApiUrl}api/dashboard`,
        {
          params: { month, year },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const { dau, newUsers, newPosts } = res.data;

      const dates = getDatesInMonth(year, month);

      const map = {};

      // 🔹 prefill ALL dates
      dates.forEach((date) => {
        map[date] = {
          day: date,
          dau: 0,
          newUsers: 0,
          newPosts: 0,
        };
      });

      // 🔹 safe merge
      dau.forEach(d => map[d.date].dau = d.count);
      newUsers.forEach(d => map[d.date].newUsers = d.count);
      newPosts.forEach(d => map[d.date].newPosts = d.count);

      setAnalytics(Object.values(map));

    } catch (err) {
      console.error("Dashboard fetch error", err);
    }
  };

  const data = analytics;

  // chat cuurent
  const chartSeries = [
    {
      name: "DAU",
      data: data.map((d) => d.dau),
    },
    {
      name: "New Users",
      data: data.map((d) => d.newUsers),
    },
    {
      name: "New Posts",
      data: data.map((d) => d.newPosts),
    },
  ];


  
  
  const chartOptions = {
    chart: {
      type: "line",
      height: 300,
      toolbar: { show: false },
      background: "#ffffff",
      animations: { enabled: true },
    },

    stroke: {
      curve: "smooth",
      width: [2, 2.5, 2],
      dashArray: [6, 0, 0],
    },

    colors: ["#b0b0b0", "#f5c518", "#1a1a2e"],

    fill: {
      type: "solid",
      opacity: 1,
    },

    markers: {
      size: [0, 0, 5],
      colors: ["#1a1a2e"],
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: { size: 6 },
    },

    dataLabels: { enabled: false },

    grid: {
      borderColor: "#f0f0f0",
      strokeDashArray: 0,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
    },

    xaxis: {
      categories: data.map(d =>
        new Date(d.day).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
        })
      ),
      tickAmount: 14,
      labels: {
        style: { fontSize: "11px", colors: "#999" },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },

    yaxis: {
      min: 0,
      tickAmount: 5,
      labels: {
        formatter: (val) => Math.round(val),
        style: { fontSize: "11px", colors: "#999" },
      },
    },

    legend: {
      show: false,
    },

    tooltip: {
      shared: true,
      intersect: false,
      theme: "light",
    },
  };


  useEffect(() => {
    getalluserscount();
    getuserscount();
    getmoderatorusers();
    getallwithdrawcount();
  }, [])

  //alluserscount api
  const getalluserscount = async () => {
    try {


      const res = await axios.get(
        `${ApiUrl}api/auth/alluserscount`,
      );
      console.log("response alluserscount", res.data)
      setAllUsersCount(res.data)
    }
    catch (e) {
      console.log("error failed", e);
    }
  }

  //usercount api
   const getuserscount = async () => {
    try {
      const res = await axios.get(
        `${ApiUrl}api/auth/usercounts`,
      );
      console.log("response userscount", res.data.result);
      setUserscount(res.data.result)
    }
    catch (e) {
      console.log("error failed", e)
    }
  }

  //allwithdraw
   const getallwithdrawcount = async () => {
    try {

      const token = localStorage.getItem("adminToken"); 
      const res = await axios.get(
        `${ApiUrl}api/totalwithdrawcount`,
          {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("response allwithdrawcount", res.data.data)
      setAllwithdrawals(res.data.data)
    }
    catch (e) {
      console.log("error failed", e)
    }
  }

  const fetchReports = async () => {
    try {
      const res = await axios.get(`${ApiUrl}api/getreport`, {
        params: { type },
      });

      console.log("API RESPONSEssss:", res.data);
      setReports(res.data.reports || []);
      setPostReports(res.data.totalposts || 0);
      setUsersReports(res.data.totalusersreports || 0);
    } catch (err) {
      console.error(err);
    }
    // setLoading(false);
  };

  //allmoderator
     const getmoderatorusers = async () => {
  try {
       const token = localStorage.getItem("adminToken");
       console.log("moderate users token dashboard" , token); 
    
       const res = await axios.get(`${ApiUrl}api/auth/usermoderate`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    
    console.log("moderator users res:", res.data.data);
    setModerateUsers(res.data.data || []);
  } catch (e) {
    console.log("Error fetching moderator users:", e.response?.data || e);
    setModerateUsers([]);
  }
};

  useEffect(() => {
    fetchReports();
  }, [type]);


  useEffect(() => {
    const fetchLiveUsers = async () => {
      const token = localStorage.getItem("adminToken"); 

      const res = await axios.get(
        `${ApiUrl}api/auth/activeusers`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("fetchliveusers", res.data)
      setLiveUsers(res.data.liveUsers);
    };

    fetchLiveUsers();

    const interval = setInterval(fetchLiveUsers, 30000);
    return () => clearInterval(interval);
  }, []);

  // console.log("collapsed", collapsed);
  // console.log("setCollapsed", setCollapsed);
  return (
    <div className="layout">
      <Layout>


        <div className="dashboard-container">

          {/* ---------------- ANALYTICS TITLE + FILTERS ---------------- */}
          <div className="graph-card">
            <div className="graph-header">
              <div className="graph-header-left">
                <h3>ANALYTICS</h3>
                <div className="graph-legend-inline">
                  <span className="legend-item">
                    <span className="legend-dot dashed-gray"></span> DAU
                  </span>
                  <span className="legend-item">
                    <span className="legend-dot solid-yellow"></span> New Users
                  </span>
                  <span className="legend-item">
                    <span className="legend-dot solid-dark"></span> New Posts
                  </span>
                </div>
              </div>

              <div className="graph-filters">
                <select
                  className="filter-pill filter-pill-yellow"
                  value={month}
                  onChange={(e) => setMonth(Number(e.target.value))}
                >
                  {monthOptions.map(({ value, label }) => (
                    <option key={value} value={value}>{label}</option>
                  ))}
                </select>

                <select
                  className="filter-pill filter-pill-dark"
                  value={year}
                  onChange={(e) => setYear(Number(e.target.value))}
                >
                  {yearOptions.map(y => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="graph-body">
              <Chart
                options={chartOptions}
                series={chartSeries}
                type="line"
                height={300}
              />
            </div>


          </div>

          <div className="cards-row">

            {/* Total Registered Users */}
            <div className="dash-stat-card">
              <div className="dash-card-top">
                <span className="dash-card-title">Total Registered Users</span>
                <span className="dash-card-pin" onClick={() => navigate("/Users")}>
                  <i className="bi bi-link-45deg"></i>
                </span>
              </div>
              <div className="dash-card-body">
                <div className="dash-count-circle">{usercount?.user_count}</div>
                <div className="dash-icon-circle">
                  <i className="bi bi-person"></i>
                </div>
              </div>
              <div className="tags-row">
                <span className="tag pink">{usercount?.freeze_count ?? 28} Freezed</span>
                <span className="tag purple">{moderateusers?.length} Moderators</span>
              </div>
            </div>

            {/* Posts */}
            <div className="dash-stat-card">
              <div className="dash-card-top">
                <span className="dash-card-title">Posts</span>
                <span className="dash-card-pin" onClick={() => navigate("/Posts")}>
                  <i className="bi bi-link-45deg"></i>
                </span>
              </div>
              <div className="dash-card-body">
                <div className="dash-count-circle">{alluserscount?.posts}</div>
                <div className="dash-icon-circle">
                  <i className="bi bi-layers"></i>
                </div>
              </div>
              <div className="tags-row">
                <span className="tag green">{alluserscount?.reels} Reels</span>
                <span className="tag aqua">{alluserscount?.videos} Videos</span>
                <span className="tag blue">{alluserscount?.imagePosts} Image</span>
                <span className="tag gray">{alluserscount?.textPosts} Text</span>
              </div>
            </div>

            {/* Reports */}
            <div className="dash-stat-card">
              <div className="dash-card-top">
                <span className="dash-card-title">Reports</span>
                <span className="dash-card-pin" onClick={() => navigate("/Reports")} style={{ cursor: "pointer" }}>
                  <i className="bi bi-link-45deg"></i>
                </span>
              </div>
              <div className="dash-card-body">
                <div className="dash-count-circle">{reports?.length}</div>
                <div className="dash-icon-circle">
                  <i className="bi bi-exclamation-triangle"></i>
                </div>
              </div>
              <div className="tags-row">
                <span className="tag blue">{usersreports} User Reports</span>
                <span className="tag green">{postsreports} Post Reports</span>
              </div>
            </div>

            {/* Withdrawals */}
            <div className="dash-stat-card">
              <div className="dash-card-top">
                <span className="dash-card-title">Withdrawals</span>
                <span className="dash-card-pin" onClick={() => navigate("/Withdrawal")}>
                  <i className="bi bi-link-45deg"></i>
                </span>
              </div>
              <div className="dash-card-body">
                <div className="dash-count-circle">{allwithdrawals?.totalWithdrawal ?? 0}</div>
                <div className="dash-icon-circle">
                  <i className="bi bi-box-arrow-up"></i>
                </div>
              </div>
              <div className="tags-row">
                <span className="tag green">{allwithdrawals?.pending} Pending</span>
                <span className="tag aqua">{allwithdrawals?.completed} Completed</span>
                <span className="tag pink">{allwithdrawals?.rejected} Rejected</span>
              </div>
            </div>

          </div>
        </div>
      </Layout>
    </div>
  );
}

